import BrandImage1 from "@data/images/partners/mitech-client-logo-01.png";
import BrandImage1Hover from "@data/images/partners/mitech-client-logo-01-hover.png";
import BrandImage2 from "@data/images/partners/mitech-client-logo-02.png";
import BrandImage2Hover from "@data/images/partners/mitech-client-logo-02-hover.png";
import BrandImage3 from "@data/images/partners/mitech-client-logo-03.png";
import BrandImage3Hover from "@data/images/partners/mitech-client-logo-03-hover.png";
import BrandImage4 from "@data/images/partners/mitech-client-logo-04.png";
import BrandImage4Hover from "@data/images/partners/mitech-client-logo-04-hover.png";
import BrandImage5 from "@data/images/partners/mitech-client-logo-05.png";
import BrandImage5Hover from "@data/images/partners/mitech-client-logo-05-hover.png";
import BrandImage6 from "@data/images/partners/mitech-client-logo-06.png";
import BrandImage6Hover from "@data/images/partners/mitech-client-logo-06-hover.png";
import BrandImage7 from "@data/images/partners/mitech-client-logo-07.png";
import BrandImage7Hover from "@data/images/partners/mitech-client-logo-07-hover.png";
import BrandImage8 from "@data/images/partners/mitech-client-logo-08.png";
import BrandImage8Hover from "@data/images/partners/mitech-client-logo-08-hover.png";
import BrandImage9 from "@data/images/partners/mitech-client-logo-09.png";
import BrandImage9Hover from "@data/images/partners/mitech-client-logo-09-hover.png";

export const data = [
    {
        image: { src: BrandImage1 },
        hoverImg: { src: BrandImage1Hover },
    },
    {
        image: { src: BrandImage2 },
        hoverImg: { src: BrandImage2Hover },
    },
    {
        image: { src: BrandImage3 },
        hoverImg: { src: BrandImage3Hover },
    },
    {
        image: { src: BrandImage4 },
        hoverImg: { src: BrandImage4Hover },
    },
    {
        image: { src: BrandImage5 },
        hoverImg: { src: BrandImage5Hover },
    },
    {
        image: { src: BrandImage6 },
        hoverImg: { src: BrandImage6Hover },
    },
    {
        image: { src: BrandImage7 },
        hoverImg: { src: BrandImage7Hover },
    },
    {
        image: { src: BrandImage8 },
        hoverImg: { src: BrandImage8Hover },
    },
    {
        image: { src: BrandImage9 },
        hoverImg: { src: BrandImage9Hover },
    },
];
